export default __webpack_public_path__ + "static/media/trivia_background.13881003.png";